export const upperCaseFirstLetter = (str: string) =>
  str
    .split(' ')
    .map((char) => (char = char.charAt(0).toUpperCase() + char.substring(1)))
    .join(' ');
